import { render, staticRenderFns } from "./DimensionCreate.vue?vue&type=template&id=308e4212&"
import script from "./DimensionCreate.vue?vue&type=script&lang=js&"
export * from "./DimensionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports